import Main from './main'
import Funnel from './funnel'

export default {
  Main,
  Funnel,
}
